import SectionLabel from "@/components/base/SectionLabel";
import { aiDigitalData } from "@/mocks/aiDigitalData";

export default function ImplementationFlowSection() {
  return (
    <section id="implementation-flow" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-14 md:mb-18 reveal">
          <SectionLabel label={aiDigitalData.implementationFlow.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {aiDigitalData.implementationFlow.title}
          </h2>
        </div>

        {/* Desktop: Horizontal flow */}
        <div className="hidden lg:block">
          <div className="relative max-w-5xl mx-auto">
            <div className="flex justify-between items-start gap-4">
              {aiDigitalData.implementationFlow.steps.map((step, idx) => (
                <div
                  key={step.num}
                  className="reveal relative flex flex-col items-center text-center flex-1"
                  style={{ transitionDelay: `${idx * 100}ms` }}
                >
                  <div className="w-12 h-12 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-base font-bold font-heading mb-3 relative z-10">
                    {idx + 1}
                  </div>
                  <h3 className="text-sm font-bold text-foreground-900 mb-2 font-heading">
                    {step.title}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed max-w-[140px]">
                    {step.desc}
                  </p>
                </div>
              ))}
            </div>
            {/* Connecting line */}
            <div className="absolute top-[23px] left-[12%] right-[12%] h-px bg-background-300" />
          </div>
        </div>

        {/* Mobile/Tablet: Vertical flow */}
        <div className="lg:hidden space-y-0">
          {aiDigitalData.implementationFlow.steps.map((step, idx) => (
            <div
              key={step.num}
              className="reveal flex gap-4 md:gap-5 items-start relative"
              style={{ transitionDelay: `${idx * 80}ms` }}
            >
              <div className="flex flex-col items-center pt-1">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-sm font-bold font-heading flex-shrink-0">
                  {idx + 1}
                </div>
                {idx < aiDigitalData.implementationFlow.steps.length - 1 && (
                  <div className="w-px flex-1 min-h-[40px] bg-background-300 mt-2" />
                )}
              </div>
              <div className="pb-6 pt-2 md:pt-2.5">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-1 font-heading">
                  {step.title}
                </h3>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  {step.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Center text */}
        <div className="text-center mt-10 md:mt-12 reveal">
          <div className="inline-block px-6 py-3 rounded-full bg-primary-50 border border-primary-200/60">
            <p className="text-sm md:text-base font-bold text-primary-700 font-heading whitespace-nowrap">
              {aiDigitalData.implementationFlow.centerText}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}